const ACCENTS = ['turmeric', 'saffron', 'chili', 'cardamom', 'soil'];

export const CATEGORY_IMAGES = {
  Rice: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800&q=80',
  'Traditional Rice': '/images/product-blend.png',
  'Pulses/Grain': '/images/product-cumin.png',
  Millets: '/images/product-pepper.png',
  Flours: '/images/product-turmeric.png',
  Spices: '/images/product-chili.png',
  Nuts: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=800&q=80',
  'Grounded Powder': '/images/product-turmeric.png',
  'Sugar Based': 'https://images.unsplash.com/photo-1606312619070-d48b4cbc1225?w=800&q=80',
  'Flattened Rice': '/images/product-blend.png',
  Vermicelli: '/images/product-blend.png',
  Pickles: '/images/product-chili.png',
  Oil: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=800&q=80',
  'Pappad Fryums': '/images/product-blend.png',
  Snacks: '/images/product-saffron.png',
  'Pooja Items': '/images/product-saffron.png',
  'Other Items': '/images/product-blend.png',
};

export const PRODUCT_CATEGORIES = [
  { label: 'Rice', subtitle: 'Premium rice varieties' },
  { label: 'Traditional Rice', subtitle: 'Heritage and native rice' },
  { label: 'Pulses/Grain', subtitle: 'Pulses, lentils and grains' },
  { label: 'Millets', subtitle: 'Nutritious native millets' },
  { label: 'Flours', subtitle: 'Fine flours and mixes' },
  { label: 'Spices', subtitle: 'Whole and ground spices' },
  { label: 'Nuts', subtitle: 'Cashews, almonds and peanuts' },
  { label: 'Grounded Powder', subtitle: 'Spice powders and blends' },
  { label: 'Sugar Based', subtitle: 'Jaggery and natural sweeteners' },
  { label: 'Flattened Rice', subtitle: 'Premium aval and flakes' },
  { label: 'Vermicelli', subtitle: 'Rice and wheat semiya' },
  { label: 'Pickles', subtitle: 'Traditional pickles' },
  { label: 'Oil', subtitle: 'Cold-pressed cooking oils' },
  { label: 'Pappad Fryums', subtitle: 'Appalam and vadagam' },
  { label: 'Snacks', subtitle: 'Murukku, chips and more' },
  { label: 'Pooja Items', subtitle: 'Ritual and pooja essentials' },
  { label: 'Other Items', subtitle: 'Custom export assortments' },
];

/** Five top-level tabs shown on the home products grid and catalog. */
export const MAIN_CATEGORY_TABS = [
  {
    label: 'Rice',
    members: ['Rice', 'Traditional Rice', 'Flattened Rice'],
  },
  {
    label: 'Spices',
    members: ['Spices', 'Grounded Powder'],
  },
  {
    label: 'Grains & Pulses',
    members: ['Pulses/Grain', 'Millets', 'Flours'],
  },
  {
    label: 'Oil & Nuts',
    members: ['Oil', 'Nuts'],
  },
  {
    label: 'Specialty',
    members: [
      'Sugar Based',
      'Vermicelli',
      'Pickles',
      'Pappad Fryums',
      'Snacks',
      'Pooja Items',
      'Other Items',
    ],
  },
];

function row(category, name, hsn) {
  return { category, name, tagline: `Premium ${name} for export`, hsn };
}

export const CATALOG = [
  // Rice
  row('Rice', 'Ponni Rice', '10063090'),
  row('Rice', 'Sona Masoori Rice', '10063090'),
  row('Rice', 'Idly Rice', '10063090'),
  row('Rice', 'Jeera Rice', '10063090'),
  row('Rice', 'Matta Rice (Long & Short Grain)', '10063090'),
  row('Rice', 'IR 64', '10063090'),
  row('Rice', 'GR11', '10063090'),
  row('Rice', 'Mootai Karuppan Rice', '10063090'),
  row('Rice', 'Kuruva', '10063090'),
  row('Rice', 'Jaya', '10063090'),
  row('Rice', 'Seeraga Samba / Jeerakasala Rice', '10063090'),
  row('Rice', 'Mottai Karupan Rice (Matta Single Boiled)', '10063090'),
  // Traditional Rice
  row('Traditional Rice', 'Mapillai Samba (Groom Rice)', '10063090'),
  row('Traditional Rice', 'Sivappu Samba', '10063090'),
  row('Traditional Rice', 'Sivapu Arisi (Red Rice)', '10063090'),
  row('Traditional Rice', 'Athur Kichilli Samba', '10063090'),
  row('Traditional Rice', 'Ponni Kichilli Samba', '10063090'),
  row('Traditional Rice', 'Kattuyanam', '10063090'),
  row('Traditional Rice', 'Karunguruvai', '10063090'),
  row('Traditional Rice', 'Poongar', '10063090'),
  row('Traditional Rice', 'Kullakar', '10063090'),
  row('Traditional Rice', 'Aruvatham Kuruvai', '10063090'),
  row('Traditional Rice', 'Thooyamalli', '10063090'),
  row('Traditional Rice', 'Ponni Thooyamalli', '10063090'),
  row('Traditional Rice', 'Black Kavuni (Black Rice)', '10063090'),
  row('Traditional Rice', 'Moongil Arisi (Bamboo Rice)', '10063090'),
  row('Traditional Rice', 'Rathasali', '10063090'),
  row('Traditional Rice', 'Ilupai Poo Samba', '10063090'),
  row('Traditional Rice', 'Handpound Rice', '10063090'),
  // Pulses/Grain
  row('Pulses/Grain', 'Toor Dal', '07136000'),
  row('Pulses/Grain', 'Bengal Gram Dal', '07132020'),
  row('Pulses/Grain', 'Urad Dal — White/Black (Split)', '07133110'),
  row('Pulses/Grain', 'Broken Urad Dal', '07133990'),
  row('Pulses/Grain', 'Moong Dal', '07133100'),
  row('Pulses/Grain', 'Mung Bean', '07133100'),
  row('Pulses/Grain', 'Horse Gram', '07135000'),
  row('Pulses/Grain', 'Cow Pea', '07133500'),
  row('Pulses/Grain', 'Channa Dal — Split', '07132020'),
  row('Pulses/Grain', 'Broad Bean', '07135000'),
  row('Pulses/Grain', 'Roasted Gram', '07139010'),
  row('Pulses/Grain', 'Black Chickpea (Small/Large)', '07132020'),
  row('Pulses/Grain', 'White Chickpea (Small/Large)', '07132010'),
  row('Pulses/Grain', 'Green Peas', '07131020'),
  row('Pulses/Grain', 'Broken Wheat', '11042900'),
  row('Pulses/Grain', 'White Semolina', '11031110'),
  row('Pulses/Grain', 'Rice Semolina', '11031900'),
  row('Pulses/Grain', 'Masoor Dal', '07134000'),
  // Millets
  row('Millets', 'Foxtail Rice', '10082160'),
  row('Millets', 'Kodo Millet Rice', '10082170'),
  row('Millets', 'Little Millet Rice', '10082930'),
  row('Millets', 'Barnyard Millet Rice', '10082140'),
  row('Millets', 'White Sorghum', '10082910'),
  row('Millets', 'Popped Corn', '10059030'),
  row('Millets', 'Round Pearl Millet', '10082029'),
  row('Millets', 'Finger Millet', '10082130'),
  row('Millets', 'Pearl Millet', '10082920'),
  row('Millets', 'Broken Pearl Millet', '10082029'),
  row('Millets', 'Native Pearl Millet', '10082120'),
  row('Millets', 'Foxtail Millet', '10082199'),
  row('Millets', 'Red Sorghum', '10079000'),
  row('Millets', 'Corn', '10051000'),
  row('Millets', 'Nine Grains', '71069110'),
  // Flours
  row('Flours', 'Maida (All Purpose Flour)', '11010000'),
  row('Flours', 'Gram Flour', '11061090'),
  row('Flours', 'Rice Flour', '11029022'),
  row('Flours', 'Foxtail Millet Flour', '11029090'),
  row('Flours', 'Corn Flour', '11022000'),
  row('Flours', 'Pearl Millet Flour', '11029090'),
  row('Flours', 'Finger Millet Flour', '11029090'),
  row('Flours', 'Murukku Flour', '19019090'),
  row('Flours', 'Bajji Bonda Mix', '21069099'),
  row('Flours', 'Red Rice Puttu Flour', '11023000'),
  row('Flours', 'Millet Chapati Flour', '11029090'),
  row('Flours', 'Millet Dosa Batter', '19012000'),
  // Spices
  row('Spices', 'Sesame Seeds (White/Black)', '12074010'),
  row('Spices', 'Coriander', '09092190'),
  row('Spices', 'Tamarind', '08134010'),
  row('Spices', 'Mustard', '12075090'),
  row('Spices', 'Cumin Seeds', '09093129'),
  row('Spices', 'Black Cumin', '09093111'),
  row('Spices', 'Black Pepper', '09041140'),
  row('Spices', 'Fennel Seeds', '09092200'),
  row('Spices', 'Fenugreek', '09109912'),
  row('Spices', 'Cinnamon', '09061030'),
  row('Spices', 'Clove', '09071090'),
  row('Spices', 'Indian Long Pepper', '09041110'),
  row('Spices', 'Poppy Seeds', '12079100'),
  row('Spices', 'Carom Seeds — Ajwain', '09109914'),
  row('Spices', 'Kapok Buds', '12119099'),
  row('Spices', 'Star Anise', '09096220'),
  row('Spices', 'Haritaki', '30049011'),
  row('Spices', 'Nutmeg Mace', '09082200'),
  row('Spices', 'Stone Moss', '12122110'),
  row('Spices', 'Rose Buds', '06031100'),
  row('Spices', 'Bay Leaves', '09104030'),
  row('Spices', 'Cardamom', '09083220'),
  row('Spices', 'Dry Ginger', '09101190'),
  row('Spices', 'Asafoetida Cubes', '13019013'),
  row('Spices', 'Asafoetida Powder', '13019013'),
  row('Spices', 'Chilli', '09042110'),
  row('Spices', 'Chilli Without Stem', '09042219'),
  row('Spices', 'Dry Red Chillies S-4 (Medium Hot)', '09042110'),
  row('Spices', 'Dry Red Chillies S-17 (Extra Hot)', '09042110'),
  row('Spices', 'Round Chilli', '09042110'),
  row('Spices', 'Round Chilli Without Stem', '09042219'),
  row('Spices', 'Kashmiri Chilli', '09042211'),
  row('Spices', 'Vasambu', '12119049'),
  row('Spices', 'Thipili', '09041110'),
  row('Spices', 'Extra Spicy Dry Chilli', '09042110'),
  // Nuts
  row('Nuts', 'Badam', '08021100'),
  row('Nuts', 'Pista', '08025200'),
  row('Nuts', 'Cashew (Whole/Broken)', '08013220'),
  row('Nuts', 'Black Grapes', '20089992'),
  row('Nuts', 'Dried Fig Fruit', '08042090'),
  row('Nuts', 'Peanuts', '12024220'),
  row('Nuts', 'Cucumber Seeds', '12099190'),
  row('Nuts', 'Dry Grapes', '08062090'),
  // Grounded Powder
  row('Grounded Powder', 'Asafoetida', '13019013'),
  row('Grounded Powder', 'Turmeric Powder', '09103030'),
  row('Grounded Powder', 'Sambar Powder', '09109100'),
  row('Grounded Powder', 'Chilli Powder (Low/Medium/Extra)', '09042211'),
  row('Grounded Powder', 'Coriander Powder', '09092200'),
  row('Grounded Powder', 'Chicken Masala Powder', '09109100'),
  row('Grounded Powder', 'Mutton Masala Powder', '09109100'),
  row('Grounded Powder', 'Garam Masala Powder', '09109100'),
  row('Grounded Powder', 'Kari Masala Powder', '09109100'),
  row('Grounded Powder', 'Kulambu Chilli Powder', '09042211'),
  row('Grounded Powder', 'Idly Chilli Powder', '09109100'),
  row('Grounded Powder', 'Vatha Kuzhambu Powder', '09109100'),
  row('Grounded Powder', 'Lemon Rice Powder', '09109100'),
  row('Grounded Powder', 'Tamarind Rice Powder', '09109100'),
  row('Grounded Powder', 'Coconut Rice Powder', '09109100'),
  row('Grounded Powder', 'Pepper Powder', '09041200'),
  row('Grounded Powder', 'Rasam Powder', '09109100'),
  row('Grounded Powder', 'Briyani Masala Powder', '09109100'),
  row('Grounded Powder', 'Cumin Powder', '09093200'),
  row('Grounded Powder', 'Fennel Powder', '09095220'),
  row('Grounded Powder', 'Cinnamon Powder', '09062000'),
  row('Grounded Powder', 'Dhall Rice Powder', '09109100'),
  row('Grounded Powder', 'Fish Fry Powder', '09109929'),
  row('Grounded Powder', 'Fish Curry Masala Powder', '09109990'),
  row('Grounded Powder', 'Curry Madras', '09109100'),
  row('Grounded Powder', 'Tandoori Masala', '09109100'),
  row('Grounded Powder', 'Chicken Masala', '09109100'),
  row('Grounded Powder', 'Chicken 65 Masala', '09109100'),
  row('Grounded Powder', 'Briyani Masala', '09109100'),
  // Sugar Based
  row('Sugar Based', 'Cane Jaggery Powder', '17011310'),
  row('Sugar Based', 'Round Jaggery', '17029010'),
  row('Sugar Based', 'Cube Jaggery', '17029010'),
  row('Sugar Based', 'Palm Jaggery', '17029010'),
  row('Sugar Based', 'Palm Sugar Cubes', '17029010'),
  row('Sugar Based', 'Dry Ginger Palm Jaggery (Big/Small)', '17029010'),
  row('Sugar Based', 'Crystal Rock Candy', '17029010'),
  row('Sugar Based', 'Diamond Crystal Rock Candy', '17049090'),
  // Flattened Rice
  row('Flattened Rice', 'Flattened Red Rice Flakes', '11051100'),
  row('Flattened Rice', 'Foxtail Millet Flakes', '10083090'),
  row('Flattened Rice', 'Ragi Flakes', '11042200'),
  row('Flattened Rice', 'Wheat Flakes', '11052000'),
  row('Flattened Rice', 'Beaten Rice', '19041020'),
  // Vermicelli
  row('Vermicelli', 'Vermicelli', '19024090'),
  row('Vermicelli', 'Finger Millet Vermicelli', '19021900'),
  row('Vermicelli', 'Pearl Millet Vermicelli', '19021900'),
  row('Vermicelli', 'Tamarind Vermicelli', '19021900'),
  row('Vermicelli', 'Lemon Vermicelli', '19021900'),
  row('Vermicelli', 'Foxtail Millet Vermicelli', '19021900'),
  row('Vermicelli', 'Kodo Millet Semiya', '19021900'),
  row('Vermicelli', 'Tomato Semiya', '19021900'),
  // Pickles
  row('Pickles', 'Mango Pickle', '20019000'),
  row('Pickles', 'Lime Pickle', '20019000'),
  row('Pickles', 'Garlic Pickle', '20019000'),
  row('Pickles', 'Ginger Pickle', '20019000'),
  row('Pickles', 'Mixed Vegetable Pickle', '20019000'),
  row('Pickles', 'Tender Mango Pickle', '20019000'),
  // Oil
  row('Oil', 'Cold Pressed Coconut Oil', '15131100'),
  row('Oil', 'Cold Pressed Groundnut Oil', '15081000'),
  row('Oil', 'Cold Pressed Gingelly Oil', '15155091'),
  row('Oil', 'Castor Oil', '15153010'),
  // Pappad Fryums
  row('Pappad Fryums', 'Appalam', '19059040'),
  row('Pappad Fryums', 'Rice Flour Vadagam', '19059040'),
  row('Pappad Fryums', 'Butter Chilli Vadagam', '19059040'),
  row('Pappad Fryums', 'Wheel Fryum Vadagam', '19059040'),
  row('Pappad Fryums', 'Mint Papad', '19059040'),
  row('Pappad Fryums', 'Sun-Dried Cluster Bean Fryums', '19059040'),
  row('Pappad Fryums', 'Sunberry Vadagam', '19059040'),
  row('Pappad Fryums', 'Sun Dried Turkey Berry Vadagam', '19059040'),
  row('Pappad Fryums', 'Rice Fryum', '19059040'),
  row('Pappad Fryums', 'Sun Dried Tomato Fryum', '19059040'),
  row('Pappad Fryums', 'Mixture of Spices Vadagam', '19059040'),
  row('Pappad Fryums', 'Tapioca Pearls Fryum', '19059040'),
  row('Pappad Fryums', 'Colour Vadagam', '19059040'),
  row('Pappad Fryums', 'Ladies Finger Vadagam', '19059040'),
  row('Pappad Fryums', 'Onion Vadagam', '19059040'),
  // Snacks
  row('Snacks', 'Banana Chips', '21069099'),
  row('Snacks', 'Banana Chips — Pepper', '21069099'),
  row('Snacks', 'Achu Murukku', '21069099'),
  row('Snacks', 'Ring Murukku', '21069099'),
  row('Snacks', 'Ragi Murukku', '21069099'),
  row('Snacks', 'Butter Murukku', '21069099'),
  row('Snacks', 'Kai Murukku', '21069099'),
  row('Snacks', 'Tapioca Stick Chips', '21069099'),
  row('Snacks', 'Tapioca Chips', '21069099'),
  row('Snacks', 'Madras Mixture', '21069099'),
  row('Snacks', 'Thattai', '21069099'),
  row('Snacks', 'Masala Peanuts', '21069099'),
  row('Snacks', 'Puffed Rice', '19041090'),
  row('Snacks', 'Masala Puffed Rice', '21069099'),
  row('Snacks', 'Peanut Burfi', '17029090'),
  row('Snacks', 'Peanut Balls', '17029090'),
  row('Snacks', 'Sesame Burfi', '17029090'),
  row('Snacks', 'Sesame Balls', '17029090'),
  row('Snacks', 'Puffed Rice Balls', '17049090'),
  // Pooja Items
  row('Pooja Items', 'Camphor Tablets', '29142990'),
  row('Pooja Items', 'Agarbatti / Incense Sticks', '33074100'),
  row('Pooja Items', 'Kumkum & Turmeric Powder', '33049990'),
  row('Pooja Items', 'Pooja Oil', '15180091'),
  // Other Items
  row('Other Items', 'Custom Export Assortments', '21069099'),
  row('Other Items', 'Private Label Products', '21069099'),
];

export const PRODUCT_FILTERS = ['All', ...PRODUCT_CATEGORIES.map((c) => c.label)];

export function toDisplayProducts(items) {
  return items.map((item, index) => ({
    id: `${item.category}-${item.name}-${index}`,
    name: item.name,
    origin: 'Tamil Nadu, India',
    tagline: item.tagline || `Premium ${item.name} for export`,
    tasting: item.hsn,
    category: item.category,
    filter: item.category,
    accent: ACCENTS[index % ACCENTS.length],
    image: CATEGORY_IMAGES[item.category] || '/images/product-blend.png',
  }));
}

export const ALL_PRODUCTS = toDisplayProducts(CATALOG);

export const FEATURED_PRODUCTS = toDisplayProducts(
  PRODUCT_CATEGORIES.map((cat) => CATALOG.find((item) => item.category === cat.label)).filter(Boolean),
);

export const PRODUCT_HUB_INITIAL_COUNT = 4;
export const PRODUCT_HUB_LOAD_COUNT = 4;

export const PRODUCT_HUB_CATEGORIES = [
  {
    label: 'Rice',
    filter: 'Rice',
    desc: 'A wide variety of rice for every cuisine and every kitchen.',
    image: CATEGORY_IMAGES.Rice,
    icon: 'wheat',
  },
  {
    label: 'Spices',
    filter: 'Spices',
    desc: 'Aromatic whole and ground spices for every cuisine and every kitchen.',
    image: CATEGORY_IMAGES.Spices,
    icon: 'flame',
  },
  {
    label: 'Oils',
    filter: 'Oil',
    desc: 'Cold-pressed coconut, groundnut, gingelly and premium cooking oils for export.',
    image: CATEGORY_IMAGES.Oil,
    icon: 'droplets',
  },
  {
    label: 'Flours',
    filter: 'Flours',
    desc: 'Fine rice flour, gram flour, millet flour and specialty baking mixes.',
    image: CATEGORY_IMAGES.Flours,
    icon: 'circle',
  },
  {
    label: 'Pulses / Grain',
    filter: 'Pulses/Grain',
    desc: 'Toor dal, moong dal, channa, urad, semolina and export-grade lentils.',
    image: CATEGORY_IMAGES['Pulses/Grain'],
    icon: 'bean',
  },
  {
    label: 'Millets',
    filter: 'Millets',
    desc: 'Foxtail, kodo, ragi, pearl millet and native grain varieties for health-focused markets.',
    image: CATEGORY_IMAGES.Millets,
    icon: 'sprout',
  },
  {
    label: 'Nuts',
    filter: 'Nuts',
    desc: 'Cashews, almonds, peanuts and dried nuts — sorted and export-ready.',
    image: CATEGORY_IMAGES.Nuts,
    icon: 'nut',
  },
  {
    label: 'Grounded Powders',
    filter: 'Grounded Powder',
    desc: 'Finely milled spice powders, sambar rasam mixes and custom blends.',
    image: CATEGORY_IMAGES['Grounded Powder'],
    icon: 'sparkles',
  },
  {
    label: 'Sugar Based',
    filter: 'Sugar Based',
    desc: 'Jaggery powder, palm jaggery, rock candy and natural sweeteners.',
    image: CATEGORY_IMAGES['Sugar Based'],
    icon: 'candy',
  },
  {
    label: 'Flattened Rice',
    filter: 'Flattened Rice',
    desc: 'Premium aval and beaten rice for retail packs and bulk supply.',
    image: CATEGORY_IMAGES['Flattened Rice'],
    icon: 'layers',
  },
  {
    label: 'Vermicelli',
    filter: 'Vermicelli',
    desc: 'Wheat and rice semiya in multiple cut sizes for export and private label.',
    image: CATEGORY_IMAGES.Vermicelli,
    icon: 'utensils',
  },
  {
    label: 'Pickles',
    filter: 'Pickles',
    desc: 'Traditional South Indian pickles and preserved condiments in bulk.',
    image: CATEGORY_IMAGES.Pickles,
    icon: 'jar',
  },
  {
    label: 'Pappad & Fryums',
    filter: 'Pappad Fryums',
    desc: 'Appalam, vadagam and sun-dried fryums for wholesale export.',
    image: CATEGORY_IMAGES['Pappad Fryums'],
    icon: 'disc',
  },
  {
    label: 'Snacks',
    filter: 'Snacks',
    desc: 'Murukku, chips, mixture and traditional fried snacks from Tamil Nadu.',
    image: CATEGORY_IMAGES.Snacks,
    icon: 'cookie',
  },
  {
    label: 'Traditional Rice',
    filter: 'Traditional Rice',
    desc: 'Heritage rice — Mapillai Samba, Karunguruvai, Kavuni, Poongar and more.',
    image: CATEGORY_IMAGES['Traditional Rice'],
    icon: 'leaf',
  },
  {
    label: 'Pooja Items',
    filter: 'Pooja Items',
    desc: 'Camphor, incense, kumkum and ritual essentials for export markets.',
    image: CATEGORY_IMAGES['Pooja Items'],
    icon: 'flower',
  },
  {
    label: 'Other Items',
    filter: 'Other Items',
    desc: 'Custom assortments, private label lines and specialty export goods on request.',
    image: CATEGORY_IMAGES['Other Items'],
    icon: 'package',
  },
];

export const SHOWCASE_CATEGORIES = [
  {
    label: 'Rice',
    filter: 'Rice',
    desc: 'Ponni, Sona Masoori, Jeera Samba & parboiled export grades.',
    image: CATEGORY_IMAGES.Rice,
    featured: true,
  },
  {
    label: 'Oil',
    filter: 'Oil',
    desc: 'Cold-pressed coconut, groundnut & gingelly oils.',
    image: CATEGORY_IMAGES.Oil,
  },
  {
    label: 'Sugar',
    filter: 'Sugar Based',
    desc: 'Jaggery powder, palm jaggery & rock candy.',
    image: CATEGORY_IMAGES['Sugar Based'],
  },
  {
    label: 'Flours',
    filter: 'Flours',
    desc: 'Rice flour, millet flour, gram flour & maida.',
    image: CATEGORY_IMAGES.Flours,
  },
  {
    label: 'Pulses',
    filter: 'Pulses/Grain',
    desc: 'Toor dal, moong dal, channa & semolina.',
    image: CATEGORY_IMAGES['Pulses/Grain'],
  },
  {
    label: 'Millets',
    filter: 'Millets',
    desc: 'Foxtail, kodo, ragi, pearl millet & more.',
    image: CATEGORY_IMAGES.Millets,
  },
];

export const BESTSELLER_NAMES = [
  'Ponni Rice',
  'Kashmiri Chilli',
  'Toor Dal',
  'Cold Pressed Coconut Oil',
];

export const BESTSELLERS = toDisplayProducts(
  BESTSELLER_NAMES.map((name) => CATALOG.find((item) => item.name === name)).filter(Boolean),
);

export const SPOTLIGHT_PRODUCT = ALL_PRODUCTS.find((p) => p.name === 'Seeraga Samba / Jeerakasala Rice')
  || ALL_PRODUCTS[0];
